export default "__VITE_ASSET__d613dca6__"